"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_modal_manager_1 = require("react-modal-manager");
exports.createModalManager = react_modal_manager_1.createModalManager;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/modals/modalmanager.js
// module id = 2240
// module chunks = 0